import { Modal, Button } from 'react-bootstrap';

const DynamicPopup = ({ show, data, onHide }) => {
  const appLanguage = typeof window !== 'undefined'
    ? localStorage.getItem('appLanguage') || 'en'
    : 'en';

  // ✅ Choose content based on language, with proper fallback chain
  const popupContent =
    appLanguage === 'hi'
      ? data?.p_detail_hi || data?.p_detail || ''
      : data?.p_detail || data?.p_detail_hi || '';

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="admission-popup-modal" contentClassName="rounded-4" backdrop="static">
      <Modal.Body className="position-relative">
        <Button variant="outline-danger bg-white" onClick={onHide} style={{position: 'absolute',top: 10,right: 10,borderRadius: '50%',fontSize: 16,zIndex: 2,width: 32,height: 32,padding: 0,lineHeight: '30px',color: 'var(--bs-danger)',}} aria-label="Close">X</Button>
        <div style={{borderRadius: '5rem',background: '#fff',padding: '1.5rem',}} dangerouslySetInnerHTML={{ __html: popupContent }} />
      </Modal.Body>
    </Modal>
  );
};

export default DynamicPopup;
